import React from "react";

const TermsOfUse = () => {

    return (
        <div>
            <div className="bg-[#ffe1cb] text-center text-gray-800 py-10">
                <div className="container mx-auto">
                    <div className="w-full lg:w-2/3 mx-auto">
                        <h1 className="text-4xl font-semibold">Terms Of Use</h1>
                        {/* <nav aria-label="breadcrumb">
              <ol className="breadcrumb flex justify-center space-x-2 mt-4">
                <li>
                  <a href="/" className="text-blue-600 hover:underline">
                    <i className="fas fa-home"></i> Home
                  </a>
                </li>
                <li className="text-gray-600">Terms Of Use</li>
              </ol>
            </nav> */}
                    </div>
                </div>
            </div>

            <div className="max-w-4xl mx-auto p-4">
                <h1 className="text-3xl font-bold mb-4">Welcome to REAIDY.IO!</h1>
                <p className="mb-4 text-gray-500">
                    These Terms and Conditions ("Terms") govern your use of the Reaidy recruitment services private limited Web Application ("Service"), which is powered by artificial intelligence and machine learning technologies to provide mock interviews. By accessing the Service, you agree to comply with and be bound by these Terms. If you do not agree to these Terms, please do not use the Service.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">Acceptance of Terms</h2>
                <p className="mb-4 text-gray-500">
                    By using REAIDY.IO, it means you accept these Terms and any additional terms and policies referenced herein.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">Use of the Service</h2>
                <h3 className="text-xl font-semibold mt-4 mb-2">Eligibility</h3>
                <p className="mb-4 text-gray-500">
                    You must be at least 13 years old to use the Service. By using the Service, you confirm that you are of legal age.
                </p>
                <h3 className="text-xl font-semibold mt-4 mb-2">Registration</h3>
                <p className="mb-4 text-gray-500">
                    To access certain features of the Service, you may be required to register for an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">Privacy</h2>
                <p className="mb-4 text-gray-500">
                    Your use of the Service is governed by our Privacy Policy, which can be found at [link]. By using the Service, you consent to the collection, use, and sharing of your information as described in our Privacy Policy.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">User Content</h2>
                <h3 className="text-xl font-semibold mt-4 mb-2">Content Submission</h3>
                <p className="mb-4 text-gray-500">
                    Users may submit mock interview responses, questions, and other content ("User Content") through the Service. By submitting User Content, you grant us a worldwide, non-exclusive, royalty-free, transferable, sublicensable license to use, reproduce, modify, adapt, publish, distribute, and display such User Content.
                </p>
                <h3 className="text-xl font-semibold mt-4 mb-2">Content Guidelines</h3>
                <p className="mb-4 text-gray-500">
                    You may not submit User Content that is illegal, offensive, defamatory, or violates the rights of others. We reserve the right to remove or restrict User Content that violates these guidelines.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">Intellectual Property</h2>
                <h3 className="text-xl font-semibold mt-4 mb-2">Ownership</h3>
                <p className="mb-4 text-gray-500">
                    All intellectual property rights related to the Service, including but not limited to the underlying AI/ML technology, software, and content, are owned by or licensed to us.
                </p>
                <h3 className="text-xl font-semibold mt-4 mb-2">Limited License</h3>
                <p className="mb-4 text-gray-500">
                    We grant you a limited, non-exclusive, non-transferable license to use the Service for its intended purpose. You may not copy, modify, distribute, or reverse engineer the Service.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">Indemnification</h2>
                <p className="mb-4 text-gray-500">
                    You agree to indemnify and hold us harmless from any claims, damages, losses, or liabilities arising out of your use of the Service or violation of these Terms.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">Termination</h2>
                <p className="mb-4 text-gray-500">
                    We reserve the right to terminate or suspend your access to the Service at any time, without notice, for any reason, including if you violate these Terms.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">Changes to Terms</h2>
                <p className="mb-4 text-gray-500">
                    We may update these Terms from time to time. It is your responsibility to review these Terms periodically. Your continued use of the Service after any changes constitutes your acceptance of the revised Terms.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">Governing Law and Jurisdiction</h2>
                <p className="mb-4 text-gray-500">
                    These Terms are governed by and construed in accordance with the laws of India. Any disputes arising from or related to these Terms or the Service shall be subject to the exclusive jurisdiction of the courts in India.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">Contact Information</h2>
                <p className="mb-4 text-gray-500">
                    If you have any questions or concerns regarding these Terms, please contact us at <a className="text-black font-semibold hover:text-primary">connect@reaidy.io.</a><br />
                    By using REAIDY, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.
                </p>

                <h2 className="text-2xl font-bold mt-6 mb-2">Refund Policy</h2>
                <p className="mb-4 text-gray-500">
                    Our company prioritizes product quality and customer satisfaction. While we do not encourage refunds, we stand behind our products with confidence. Each request is evaluated on a case-by-case basis, ensuring fairness and integrity. We're committed to addressing any concerns and providing exceptional support. Your satisfaction is our top priority.
                </p>

                {/* Additional sections can be added similarly */}
            </div>
        </div>
    );
};

export default TermsOfUse;
